import { useEffect } from "react"
import { Modal } from "antd"

const UMCModal = (props) => {

    useEffect(() => {
        return () => {
            Modal.destroyAll()
        }
    }, [])

    return <Modal
        {...props}
        title={props.title}
        open={props.open}
        onOk={props.onOk}
        onCancel={props.onCancel}
        className={props.className}
        okText={props.okText}
        cancelText={props.cancelText}
        footer={props.footer !== undefined ? props.footer : undefined}
        centered={props.centered}
        style={props.style}
        width={props.width}
        maskClosable={props.maskClosable !== undefined ? props.maskClosable : false}
        okButtonProps={props.okButtonProps}
        cancelButtonProps={props.cancelButtonProps}
        closable={props.closable !== undefined ? props.closable : false}
    >
        {props.content || props.children}
    </Modal>
}

export default UMCModal